export const baseUrl = "https://hussainiyah.ribox.me"
// export const baseUrl = "https://hussainiyahdev.isiteguru.com"
export const url = baseUrl +  "/api/"
// export const node_image_url = "http://161.97.108.84:3006"
export const node_image_url = "https://www.hussainiyahnode.isiteguru.com"
export const minimum_distance_km = 0.1;
export function formatDateTime(date = new Date(),condition="date") {
  const pad = n => String(n).padStart(2, '0');

  console.log('date',date)

  const year = date?.getFullYear();
  const month = pad(date.getMonth() + 1); // Months are 0-indexed
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  if (condition == "date"){
    return `${year}-${month}-${day}`;
  }else{
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
